<app-page-header subtitle="Artikelenbeheer"></app-page-header>
<div class="container-xl mt-4 mb-4">
    <div class="table-responsive">
        <table class="table table-sm table-hover table-striped mb-0">
            <thead class="table-light">
                <tr>
                    <th class="text-end">Volgorde</th>
                    <th>Groep</th>
                    <th>Naam</th>
                    <th>Eenheid</th>
                    <th class="text-end">m² per eenheid</th>
                    <th class="text-center">AI voorstellen</th>
                    <th>AI bedrijfsregel</th>
                </tr>
            </thead>
            <tbody>
                @for (article of articles(); track article.id) {
                    <tr>
                        <td class="text-end">{{ article.order }}</td>
                        <td>{{ article.group }}</td>
                        <td>
                            <strong>{{ article.name }}</strong>
                        </td>
                        <td>
                            <small>{{ article.article_unit_type?.name }}</small>
                        </td>
                        <td class="text-end text-input" (click)="factorInput.focus()">
                            <input
                                #factorInput
                                [ngModel]="article.factor | number: '1.2-2' : 'en'"
                                [ngModelOptions]="{ updateOn: 'blur' }"
                                (ngModelChange)="update(article, { factor: $event })"
                                appDecimalInput
                                decimalInput="2"
                                inputmode="decimal"
                                placeholder="-"
                                type="text" />
                        </td>
                        <td class="checkbox-cell">
                            <mat-checkbox
                                [checked]="article.ai_apply"
                                (change)="update(article, { ai_apply: $event.checked })"></mat-checkbox>
                        </td>
                        <td class="text-input ai-rule-cell" (click)="aiRuleInput.focus()">
                            <input
                                #aiRuleInput
                                type="text"
                                placeholder="-"
                                [value]="article.ai_business_rule ?? ''"
                                (change)="update(article, { ai_business_rule: aiRuleInput.value.trim() || null })" />
                        </td>
                    </tr>
                } @empty {
                    <tr>
                        <td class="text-muted" colspan="7">Geen artikelen</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
